import { BackendApi } from '@/services/backend_api'

export default {
  auditParkStages () {
    return BackendApi.getClient().get('maintenance/park-stages/audit')
      .then(response => response)
      .catch(e => { throw e })
  },
  syncParkStages () {
    return BackendApi.getClient().post('maintenance/park-stages/sync')
      .then(response => response)
      .catch(e => { throw e })
  },
  updateManagementEntityLegalNatureOptions () {
    return BackendApi.getClient().post('maintenance/management-entity-legal-nature-options')
      .then(response => response)
      .catch(e => { throw e })
  },
  fixParkLandAreas (parkId) {
    return BackendApi.getClient().post('maintenance/park-land-areas/fix', { parkId: parkId })
      .then(response => response)
      .catch(e => { throw e })
  }
}



// WEBPACK FOOTER //
// ./src/services/resource_client/maintenance.js